var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClientiImportaCsv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,980.07v-154.57c0-21.34,17.3-38.64,38.64-38.64h35.43c21.34,0,38.64,17.3,38.64,38.64h0c0,21.34,17.3,38.64,38.64,38.64h721.3c21.34,0,38.64-17.3,38.64-38.64h0c0-21.34,17.3-38.64,38.64-38.64h35.42c21.34,0,38.64,17.3,38.64,38.64v154.57c0,21.34-17.3,38.64-38.64,38.64H38.64c-21.34,0-38.64-17.3-38.64-38.64ZM822.19,400.58l-136.27-.1c-21.35-.02-38.67,17.29-38.67,38.64v270.46c0,21.34-17.3,38.64-38.64,38.64h-189.99c-21.34,0-38.64-17.3-38.64-38.64v-264.05c0-21.34-17.3-38.64-38.64-38.64h-138.87c-33.91,0-51.38-40.57-28.07-65.2L481.26,17.37c15.04-15.9,40.27-16.14,55.61-.54l312.89,318.01c24.05,24.44,6.72,65.77-27.57,65.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClientiImportaCsv);
export default __webpack_public_path__ + "static/media/menu-clienti-importa-csv.db56513e169744bf209abf6abdc1f8bf.svg";
export { ForwardRef as ReactComponent };